"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mergePaginationItems(page, limit, previous, pageItems) {
    return [
        ...previous.slice(0, (page - 1) * limit),
        ...pageItems,
        ...previous.slice((page - 1) * limit + pageItems.length),
    ];
}
exports.default = mergePaginationItems;
//# sourceMappingURL=mergePaginationItems.js.map